import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';

// import { ColorsService } from './colors/colors.service';

// https://angular.io/styleguide#!#04-10
@NgModule({
  declarations: [],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, ToastrModule.forRoot()],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule, ToastrModule],
  // providers: [ColorsService]
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
